<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="border-bottom border-gray d-flex align-items-center justify-content-center mt-3 pb-3 mb-0 h5"
     i18n>
    <i class="ni ni-badge mr-3 "></i>
    Roles
</div>
<div class="m-5">
    <div class="content-wrapper">
        <h1 class="display-1 mb-5"
            i18n>
            Roles
        </h1>
        <section class="col-xl-0 p-0 mb-5">
            <app-data-table-ajax url="/roles"
                                 responseKey="roles"
                                 limit="10"
                                 [displaySearch]="false"
                                 [columns]="columns"
                                 [template]="rowDetails"
                                 [extendRow]="true"
                                 (rowClicked)="onRowClicked($event)">

            </app-data-table-ajax>
        </section>
    </div>
</div>

<ng-template #rowDetails
             let-row="row">
    <div class="p-4 col">
        <app-role-users-table displayMode="view"
            [roleId]="row.id"></app-role-users-table>
    </div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/access-management/roles/roles-list/roles-list.component.html